import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon, Alert } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import TextoInput from "../../../general/componentes/TextoInput";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { ComplementosFecha } from "../../config_general/modelo/ComplementosFecha";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { FiltroAdminParametros, Parametro } from "../modelo/AdminParametro";
import { consultarParametros, limpiarMensajesParametros, ventanaAyudaParametro } from "../modulos/adminParametroActions";
import TablaAdminParametros from "./TablaAdminParametros";
import ConsultarReporteXLS from "../../descarga_reporte/componentes/ConsultarReporteXLS";
import { TipoReportes } from "../../descarga_reporte/modelo/TiposReporte";
import { descargarReporteXLS } from "../../descarga_reporte/modulos/descargaReporteActions";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { coincidenciaCodigoParametro, coincidenciaValorParametro, complementoFechaIngresoParametro, fechaIngresoParametro } from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaParametros } from "../../config_general/modelo/TextoVentanaAyuda";

class AdministradorParametros extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            ventanaAyuda: true,
            showAlert: true
        };
    }

    componentWillMount() {
        const ventanaDesplegada = this.props.ventanaAyudaParametro;
        ventanaDesplegada ? this.setState({ ventanaAyuda: false }) : this.props.dispatch(ventanaAyudaParametro());
    }

    handleDismissAlert() {
        this.setState({ showAlert: false });
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({ showAlert: nextProps.showAlert });
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesParametros());
    }

    render() {
        const { parametros, estado, estadoAccion, mensajeAccion, paginas, tamanoPagina, paginaActual } = this.props;

        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Administración Parámetros
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta de parámetros</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="codigo">Texto Coincidencia Código</label>
                                                <TextoAyuda texto={coincidenciaCodigoParametro} />
                                                <TextoInput name="codigo" placeholder="Ingrese código" maxLength={10} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="valor">Texto Coincidencia Valor</label>
                                                <TextoAyuda texto={coincidenciaValorParametro} />
                                                <TextoInput name="valor" placeholder="Ingrese valor" maxLength={10} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Ingreso Registro</label>
                                                <TextoAyuda texto={fechaIngresoParametro} />
                                                <DatePickerSura name={"fecha"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="complementoFecha">Complemento Fecha</label>
                                                <TextoAyuda texto={complementoFechaIngresoParametro} />
                                                <TextoInputSelector name="complementoFecha" maestro={this.listarSignoFechas()} />
                                                {errors.complementoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.complementoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    <ConsultarReporteXLS tipoReporte={TipoReportes.PARAMETROS} onDescargar={this.descargarXLS} />
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderAlertaAccion(estadoAccion, mensajeAccion)}
                    {this.renderTablaAdminGlosas(parametros, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderAlertaAccion(estadoAccion: REQUEST, mensajeAccion: string) {
        switch (estadoAccion) {
            case REQUEST.SUCCESS:
                return this.state.showAlert && this.renderAlertaExito();
            case REQUEST.ERROR:
                return this.state.showAlert && this.renderAlertaError(mensajeAccion);
            default:
                return false;
        }
    }

    renderAlertaError(mensajeAccion: string) {
        return (
            <Alert bsStyle="danger" onDismiss={() => this.handleDismissAlert()}>
                <h4>ERROR !</h4>
                <p style={{ fontSize: "15px", color: "#a94442" }}>
                    Ocurrió un error realizando la acción. <b>Error:</b> {mensajeAccion}.
                </p>
            </Alert>
        );
    }

    renderAlertaExito() {
        return (
            <Alert bsStyle="success" onDismiss={() => this.handleDismissAlert()}>
                <h4>EXITO !</h4>
                <p style={{ fontSize: "15px" }}>
                    La acción se realizó con éxito.
                </p>
            </Alert>
        );
    }

    renderTablaAdminGlosas(parametros: Array<Parametro>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!parametros || !parametros.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado parámetros"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaAdminParametros
                                parametros={parametros}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaParametros}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color : "#000000"}}>Por medio de esta ventana podrás consultar o exportar a un archivo de Excel los parámetros existentes que definen el funcionamiento de SAT,
                    luego de consultarlos se tiene la opción de crear, actualizar o borrar un parámetro, 
                    opciones que se encuentran en la columna de Acción.
                    <br />
                    <br />
                    Es <strong style={{ color: "#e57777"}}>importante</strong> antes de realizar cualquier modificación sobre un parámetro tener en cuenta que
                    este cumple una función dentro de la aplicación lo que podría llevar a la generación de errores, desconfiguración o comportamiento
                    inesperado de la aplicación.
                    <br />
                    <br />
                    Se recomienda antes de modificarlos consultar con TI el impacto de cambiar el parámetro o sus valores.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    filtros(): FiltroAdminParametros {
        return {
            codigo: this.state.codigo,
            valor: this.state.valor,
            fecha: this.state.fecha,
            complementoFecha: this.state.complementoFecha
        };
    }

    consultaPaginada = (filtro: FiltroAdminParametros) => {
        this.props.dispatch(consultarParametros(filtro));
    }

    onSubmit = (values: any) => {
        const codigo = values.codigo ? values.codigo.valueOf() : undefined;
        const valor = values.valor ? values.valor.valueOf() : undefined;
        const fecha = values.fecha ? values.fecha.valueOf() : undefined;
        const complementoFecha = values.complementoFecha ? Number(values.complementoFecha.value) : undefined;

        const filtro: FiltroAdminParametros = {
            codigo: codigo,
            valor: valor,
            fecha: fecha,
            complementoFecha: complementoFecha,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            codigo: codigo,
            valor: valor,
            fecha: fecha,
            complementoFecha: complementoFecha,
            filtro: filtro
        });

        this.props.dispatch(consultarParametros(filtro));
    }

    validate = (values: any) => {
        const errors = {
            fecha: undefined,
            complementoFecha: undefined
        };

        if (values.fecha && !values.complementoFecha)
            errors.complementoFecha = "Por favor seleccione una de las opciones";

        return errors;
    }

    listarSignoFechas = () => {
        return [].concat(
            ComplementosFecha.map(value => ({
                value: value.codigo,
                label: value.nombre
            })
            ));
    }

    descargarXLS = (tipo: TipoReportes) => {
        this.props.dispatch(descargarReporteXLS(tipo));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estado: R.pathOr([], ["administrador_parametros", "estado"])(store),
        estadoAccion: R.pathOr([], ["administrador_parametros", "estadoAccion"])(store),
        mensajeAccion: R.pathOr([], ["administrador_parametros", "mensajeAccion"])(store),
        showAlert: R.pathOr([], ["administrador_parametros", "showAlert"])(store),
        parametros: R.pathOr([], ["administrador_parametros", "parametros"])(store),
        paginas: R.pathOr([], ["administrador_parametros", "paginas"])(store),
        paginaActual: R.pathOr([], ["administrador_parametros", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["administrador_parametros", "tamanoPagina"])(store),
        totalParametrosConsulta: R.pathOr([], ["administrador_parametros", "totalParametrosConsulta"])(store),
        ventanaAyudaParametro: R.pathOr(undefined, ["administrador_parametros", "ventanaAyudaParametro"])(store)
    };
})(AdministradorParametros);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/componentes/AdministradorParametros.tsx